// at the stage's start 50%
// [0, 0.4],
// at the stage's third frame 50%
// [2, 0.5],
type Distribution<TRatio> = Array<[offset: number, ratio: TRatio]>;

export const setForDistribution = <TRatio>(
  distribution: Distribution<TRatio>,
  offset: number,
  ratio: TRatio,
) => {
  const tuple = distribution.find(([_offset]) => _offset === offset);

  if (tuple == null) {
    // new tuple
    distribution.push([offset, ratio]);
  } else {
    // update existing tuple
    tuple[1] = ratio;
  }
};

export const removeForDistribution = (
  distribution: Distribution<unknown>,
  offset: number,
) => {
  const startIndex = distribution.findIndex(([_offset]) => _offset === offset);

  if (startIndex === -1) {
    return;
  }

  distribution.splice(startIndex, 1);
};

export const toSortedForDistribution = <TRatio>(
  distribution: Distribution<TRatio>,
) => ({
  sorted: distribution.toSorted(
    ([offsetLeft], [offsetRight]) => offsetLeft - offsetRight,
  ),
});

export const getAtOffsetForDistribution = <TRatio>(
  distribution: { sorted: Distribution<TRatio> },
  offset: number,
) => {
  const frameDistribution = distribution.sorted.find(
    ([_offset]) => _offset === offset,
  );

  return frameDistribution?.[1] ?? null;
};
